/**
 * SweetAlert2 instancia pre-configurada con el tema de Marcos (rojo #F5323E)
 */
import Swal from 'sweetalert2';

const KiaSwal = Swal.mixin({
  confirmButtonColor: '#f5323e',
  cancelButtonColor: '#6c757d',
  buttonsStyling: true,
  focusConfirm: false,
});

export default KiaSwal;
